/* import __COLOCATED_TEMPLATE__ from './ticket-status-select-item.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type TicketStateService from 'embercom/services/ticket-state-service';
import type TicketCustomState from 'embercom/objects/inbox/ticket-custom-state';
import { localisedCustomStateAdminLabel } from 'embercom/lib/inbox2/ticket-custom-states';
import type IntlService from 'embercom/services/intl';

interface Args {
  componentAttrs: {
    state: TicketCustomState | undefined;
  };
  wrapperClass?: string;
}

interface Signature {
  Args: Args;
}

export default class TicketStatusSelectItem extends Component<Signature> {
  @service declare ticketStateService: TicketStateService;
  @service declare intl: IntlService;

  get stateCssClass(): string {
    let state = this.args.componentAttrs.state;
    if (!state) {
      return '';
    }
    let styling = this.ticketStateService.getIconForSystemState(state.systemState);
    return styling.cssClass;
  }

  get displayText(): string {
    let state = this.args.componentAttrs.state;
    if (!state) {
      return '';
    }
    return localisedCustomStateAdminLabel(state.adminLabel, this.intl);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::TicketAttribute::TicketStatusSelectItem': typeof TicketStatusSelectItem;
    'inbox2/ticket-attribute/ticket-status-select-item': typeof TicketStatusSelectItem;
  }
}
